import * as React from 'react';

import ControlledNumericInput from 'ui-library/inputs/ControlledNumericInput';
import {LabelStyle} from 'ui-library/inputs/InputConstants';
import InputWrapper from 'ui-library/inputs/InputWrapper';

interface BindingRegionMinLengthProps {
  bindingRegionMinLength: number | null;
  updateBindingRegionMinLength: (bindingRegionMinLength: number | null) => void;
  isDisabled: boolean;
}

/**
 * An input to set minimum binding region length in Golden Gate assembly.
 *
 * @param props Component props
 * @param {(number | null)} props.bindingRegionMinLength The minimum length, in base pairs, of the primer binding region.
 * @param {function} props.updateBindingRegionMinLength A function that takes a new binding region minimum length and uses it to update state.
 * @constructor
 */
export function BindingRegionMinLength(props: BindingRegionMinLengthProps): JSX.Element {
  return (
    <InputWrapper
      id="bindingRegionMinLength"
      label="Binding region - min. length (bp)"
      labelStyle={LabelStyle.LABEL}
      isRequired={true}
    >
      <ControlledNumericInput
        value={props.bindingRegionMinLength}
        min={0}
        required={true}
        onChange={(e) => {
          props.updateBindingRegionMinLength(e.target.numericValue);
        }}
        isDisabled={props.isDisabled}
      />
    </InputWrapper>
  );
}
